import { RequestDto } from '@r1-frontend/api-domru/api-content/v1/geography/get-city-info/dto/RequestDto';

import { IRequest } from '@r1-frontend/shared/types/IRequest';

const getCityInfo = (queryParams: RequestDto): IRequest => ({
    uri: '/v1/geography/get-city-info',
    method: 'GET',
    queryParams,
});

export type { RequestDto };
export type { ResponseDto } from './dto/ResponseDto';

export default getCityInfo;


